import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { Link } from "react-router-dom";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import React, { useState, useEffect } from "react";
import "./styles.css";
import { motion } from "framer-motion";
import { IconButton } from "@mui/material";
import { addToWatchlist } from "../../../functions/addToWatchlist";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { hasBeenAdded } from "../../../functions/hasBeenAdded";
import { removeFromWatchlist } from "../../../functions/removeFromWatchlist";

export default function GridComponent({ coin, delay, isWatchlistPage }) {
  const id = coin?.id;
  const [added, setAdded] = useState(() => (id ? hasBeenAdded(id) : false));

  useEffect(() => {
    setAdded(id ? hasBeenAdded(id) : false);
  }, [id]);

  const pct = Number(coin?.price_change_percentage_24h);
  const price = Number(coin?.current_price);
  const mcap = Number(coin?.market_cap);
  const vol = Number(coin?.total_volume);
  const hasPct = Number.isFinite(pct);
  const isDown = hasPct && pct < 0;
  const priceStr = Number.isFinite(price) ? price.toFixed(3) : "—";
  const pctStr = hasPct ? pct.toFixed(2) : "—";
  const mcapDisplay = Number.isFinite(mcap) ? mcap.toLocaleString() : "—";
  const volDisplay = Number.isFinite(vol) ? vol.toLocaleString() : "—";

  if (!id) {
    return null;
  }

  return (
    <Link to={`/coin/${id}`} className="coin-link">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: delay }}
        style={{ display: isWatchlistPage && !added && "none" }}
        className={`coin-container ${isDown && "coin-container-red"}`}
      >
        <div className="coin-rank">
          <div className="coin-item">
            <img className="coin-image" src={coin.image} alt="coin" />
            <div className="coin-details">
              <p className="coin-symbol">{coin.symbol}</p>
              <p className="coin-name">{coin.name}</p>
            </div>
          </div>
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              if (added) {
                removeFromWatchlist(id);
                setAdded(false);
              } else {
                addToWatchlist(id);
                setAdded(true);
              }
            }}
          >
            {added ? (
              <StarRoundedIcon
                className={`watchlist-icon ${
                  isDown && "watchlist-icon-red"
                } `}
                sx={{ fontSize: "2rem !important" }}
              />
            ) : (
              <StarBorderRoundedIcon
                className={`watchlist-icon ${
                  isDown && "watchlist-icon-red"
                } `}
                sx={{ fontSize: "2rem !important" }}
              />
            )}
          </IconButton>
        </div>
        <div className="coin-price-change">
          {isDown ? (
            <div className="coin-percentage">
              <p className="red">{pctStr}%</p>
              <TrendingDownIcon className="red" />
            </div>
          ) : (
            <div className="coin-percentage">
              <p className="green">{pctStr}%</p>
              <TrendingUpIcon className="green" />
            </div>
          )}
        </div>
        <div className="current-price">
          {isDown ? (
            <p className="current-price-red">${priceStr}</p>
          ) : (
            <p className="current-price-green">${priceStr}</p>
          )}
        </div>
        <div className="market-details">
          <p>
            <b>Market Cap:</b> ${mcapDisplay}
          </p>
          <p>
            <b>Total Volume:</b> ${volDisplay}
          </p>
        </div>
      </motion.div>
    </Link>
  );
}
